import Entity from '../entity'

export default class SecondHand extends Entity<number> {
    title: string = '';
    publishName: string = '';
    phoneNumber: string = '';
    address: string = '';
    price: number = 0;
    description: string = '';
    isPublish: boolean = false;
    showOnHome: boolean = false;
    displayOrder: number = 0;
    secondHandImages: Array<any> = [];
    creationTime: Date = new Date();
    creatorUserId: number = 0;
}